/* eslint-disable */
/*
* crewplanning.js
*
* Description: Holds 'Stores' Logic for Module:'Crewplanning2 - Calendar'.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew2 - Crewplanning"
* Copyright 2018,2019,2020,2021,2022,2023 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
*
*/
import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import { eventBus } from '../../../main';


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> cc -- crewcalendar -----------------------------
    cc_ListEmployeesSchedulerDetails: {}, // Results::ListEmployeesSchedulerDetails
    cc_ListEmployeesSchedulerSearchData: {}, // SearchData
    cc_Resources: [], // stores
    cc_Events: [],
    cc_ResourceTimeRanges: [],
    cc_ResourceTimeRanges_BirthdatesCache: [], // Buffer/Cache
    cc_ResourceTimeRangesWarningsList: [],


    // >>> cc -- crewcalendar - flags ---------------------
    dataIsFresh: true, // everything fresh? or some HTL/PRO did get set?
    // >>> cc -- crewcalendar - multi selected events -----
    selectedMultiEvents: [], // multiEventSelect
    selectedMultiEventsEntireRecord: [], // multiEventSelect (entire Rrcord)
    selectedMultiResources: [], // Multi Reources Select

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: 'CrewCalendar'
    ***************************************************************************/
    /***************************************************************************
    * get_cc_ListEmployeesSchedulerDetails()
    *
    * Desc:
    * Note:
    *
    */
    get_cc_ListEmployeesSchedulerDetails: state => {

        return state.cc_ListEmployeesSchedulerDetails;

    }, // eo function get_cc_ListEmployeesSchedulerDetails()


    /***************************************************************************
    * get_Resources()
    *
    * Desc:
    * Note:
    *
    */
    get_Resources: state => {

        state.cc_Resources = state.cc_Resources.sort((a, b) => {

            if (a.order < b.order) {
                return -1;
            }
            if (a.order > b.order) {
                return 1;
            }

            if (a.lastName < b.lastName) {
                return -1;
            }
            if (a.lastName > b.lastName) {
                return 1;
            }

        });


        return state.cc_Resources;

    }, // eo function get_Resources()


    /***************************************************************************
    * get_Resource()
    *
    * Desc: Get a single Resource.
    * Note:
    * Note: Getter with Payload.
    * Note: type::'selectedhotellist' => 'HOTEL' & 'PROCEEDING' Lists.
    *
    */
    get_Resource: state => payload => {

        let sr = state.cc_Resources.find(resource => resource.id === payload.resourceId),
            srt = null;


        if (payload.type === 'selectedhotellist') {
            srt = sr.firstName.trim() + ', ' + sr.lastName.trim() + ' (' + sr.contractFunction + ')';
        }


        return srt;

    }, // eo function get_Resource()


    /***************************************************************************
    * get_Events()
    *
    * Desc:
    * Note:
    *
    */
    get_Events: state => {

        return state.cc_Events;

    }, // eo function get_Events()


    /***************************************************************************
    * get_ResourceTimeRanges()
    *
    * Desc:
    * Note:
    *
    */
    get_ResourceTimeRanges: state => {

        return state.cc_ResourceTimeRanges;

    }, // eo function get_ResourceTimeRanges()


    /***************************************************************************
    * get_ResourceTimeRangesWarningsList()
    *
    * Desc:
    * Note:
    *
    */
    get_ResourceTimeRangesWarningsList: state => {

        let copy_cc_ResourceTimeRangesWarningsList = [];


        // state.cc_ResourceTimeRangesWarningsList.forEach((item) => {
        //     if (item.restrictions.length > 0) {
        //         state.cc_Resources.forEach((resource) => {
        //             if (resource.id === item.idResource) {
        //                 item.resource = resource.filterableName;
        //                 copy_cc_ResourceTimeRangesWarningsList.push(item);
        //             }
        //         });
        //     }
        // });


        state.cc_ResourceTimeRangesWarningsList.forEach((item) => {
            if (item.restrictions.length > 0) {
                // Filtere die Objekte in item.restrictions nach item.restrictions.error === true
                const filteredRestrictions = item.restrictions.filter((restriction) => restriction.error === true);

                if (filteredRestrictions.length > 0) {
                    state.cc_Resources.forEach((resource) => {
                        if (resource.id === item.idResource) {
                            item.resource = resource.filterableName;
                            item.restrictions = filteredRestrictions; // Setze die gefilterten Einschränkungen zurück
                            copy_cc_ResourceTimeRangesWarningsList.push(item);
                        }
                    });
                }
            }
        });



        return copy_cc_ResourceTimeRangesWarningsList;

    }, // eo function get_ResourceTimeRangesWarningsList()




    /***************************************************************************
    * Getters: 'CrewCalendar' - Get selected Multi Events/Resources.
    ***************************************************************************/
    /***************************************************************************
    * get_selectedMultiEvents()
    *
    * Desc: Return selected Multi Events.
    * Note: paylod:: e.g.: 'HOTEL'
    * Note: Getter with Payload.
    *
    */
    get_selectedMultiEvents: state => payload => {

        if (payload !== undefined && payload !== null) {
            return state.selectedMultiEvents.filter(x => x.name == payload);
        } else {
            return state.selectedMultiEvents;
        }

    }, // eo function get_selectedMultiEvents()


    /***************************************************************************
    * get_selectedMultiEventsEntireRecord()
    *
    * Desc: Return selected Multi Events. (entire Records)
    *
    */
    get_selectedMultiEventsEntireRecord: state => {

        return state.selectedMultiEventsEntireRecord;

    }, // eo function get_selectedMultiEventsEntireRecord()


    /***************************************************************************
    * get_selectedMultiResources()
    *
    * Desc: Return selected Multi Resources.
    *
    */
    get_selectedMultiResources: state => {

        return state.selectedMultiResources;

    }, // eo function get_selectedMultiResources()




    /***************************************************************************
    * get_areThereTrainingsFlightsOnDateAndResources()
    *
    * Desc: Find out if there are Trainings Flights on the selected Date and Resources.
    * Note: Run through all Events => Search for right Ressource and Date =>
    * Note: Check if there is a Training Flight => Check Roles
    * Note:
    *
    */
    get_areThereTrainingsFlightsOnDateAndResources: state => payload => {

        return state.cc_Events.some(flight => {
            if (
                (flight.resourceId === payload.markedRessources[0].id ||
                    flight.resourceId === payload.markedRessources[1].id) &&
                    moment(flight.startDate).isSame(moment(payload.theData.date), 'day') &&
                    flight.name === 'FLIGHT' &&
                    (Vue.prototype.$checkSingleOccurrence(flight.crew, 'I') ||
                     Vue.prototype.$checkSingleOccurrence(flight.crew, 'T') ||
                     Vue.prototype.$checkSingleOccurrence(flight.crew, 'C'))
            ) {
                return true;
            }
            return false;
        });

    }, // eo function get_areThereTrainingsFlightsOnDateAndResources()

};




//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: 'CrewCalendar' - Load
    ***************************************************************************/
    /***************************************************************************
    * mut_load_ListEmployeesSchedulerDetails()
    *
    * Desc:
    * Note: payload: { response: response.data, resetBefore: true }
    * TODO: Faster Array-Handling
    *
    */
    mut_load_ListEmployeesSchedulerDetails: (state, payload) => {

        const eventColors = Vue.prototype.$getEventColors_Calendar();

        let resourceId = null,
            filterableName = null,
            order = null,
            tmpArrayResources = [],
            tmpArrayFlights = [],
            tmpArrayCiCos = [],
            tmpArrayTrainings = [],
            tmpArrayProceedings = [],
            tmpArrayHotels = [],
            tmpArrayBreaks = [],
            tmpArrayResourceBirthdate = [],
            utcDepartureTime = null,
            utcArrivalTimeSleep = null,
            utcDepartureTimeSleep = null,
            utcDepartureTimeActivation = null,
            utcArrivalTime = null,
            year_departure_time = null,
            month_departure_time = null,
            day_departure_time = null,
            hours_departure_time = null,
            minutes_departure_time = null,
            year_arrival_time = null,
            month_arrival_time = null,
            day_arrival_time = null,
            hours_arrival_time = null,
            minutes_arrival_time = null,
            t = null,
            t2 = null, // ci
            t3 = null, // co
            datebefore = null, // ci
            resourceIdBefore = null,
            datebefore2 = null, // co
            resourceIdBefore2 = null,
            mycrew = '',
            tmp = '',
            roles = '',
            note = '',
            nameEvent = '',
            tooltiptData = '',
            startDateTmp = '',
            endDateTmp = '',
            style = null;


        // >>> -----------------------------------------------------------------// save all, reset
        state.cc_ListEmployeesSchedulerDetails = payload;                       // save all in state


        // >>> -----------------------------------------------------------------// forEach - Results
        payload.forEach((item, i) => {

            resourceId = item.crewMemberInfo.id;                                // remember 'resourceId'

            filterableName = item.crewMemberInfo.lastName + ' ' + item.crewMemberInfo.firstName + ' ' + item.crewMemberInfo.contract3Code;
            item.crewMemberInfo.filterableName = filterableName;                // add filterableName
            item.crewMemberInfo.lastName = item.crewMemberInfo.lastName.trim();
            item.crewMemberInfo.firstName = item.crewMemberInfo.firstName.trim();
            item.crewMemberInfo.firstNameFirstLetter = item.crewMemberInfo.firstName[0];
            item.crewMemberInfo.lastNameFirstLetter = item.crewMemberInfo.lastName[0];


            // >>> ----------------------------------------                     // sort resources
            if (item.crewMemberInfo.contractFunction === 'CP') {
                order = '1';
            } else if (item.crewMemberInfo.contractFunction === 'FO') {
                order = '2';
            } else if (item.crewMemberInfo.contractFunction === 'SCCM') {
                order = '3';
            } else if (item.crewMemberInfo.contractFunction === 'CA') {
                order = '4';
            }
            item.crewMemberInfo.order = order;                                  // add order

            tmpArrayResources.push(item.crewMemberInfo);                        // save 'crewMemberInfo'


            // >>> ----------------------------------------                     // hasBirthdate? (resourceTimeRange)
            if (item.crewMemberInfo.hasBirthdate) {
                startDateTmp = state.cc_ListEmployeesSchedulerSearchData.from.substring(0,4) + moment(item.crewMemberInfo.genBirthdate).format('-MM-DD').toString() + 'T00:00';
                endDateTmp = state.cc_ListEmployeesSchedulerSearchData.from.substring(0,4) + moment(item.crewMemberInfo.genBirthdate).format('-MM-DD').toString() + 'T23:59';

                tmpArrayResourceBirthdate.push(
                    { resourceId : item.crewMemberInfo.id, startDate : startDateTmp, endDate : endDateTmp, name : 'BD', cls: 'birthdate' },
                );

            }
            // <<< ----------------------------------------


            // >>> 'flightInfos/cicos' --------------------
            if (item.flightInfos.length) {
                item.flightInfos.forEach(flight => {

                    // >>> Flight -----------------------------------
                    let getColors = eventColors.find(colors => colors.duty === 'FLIGHT');

                    note = ''; // reset
                    nameEvent = '';
                    tooltiptData = '';

                    // >>> Notes & More ----------------------------------------
                    flight.type = 'FLIGHT';
                    // flight.flightComment = 'Michael'; // tmp
                    tooltiptData = Vue.prototype.$buildEventNote(flight);
                    note += tooltiptData.note;
                    nameEvent += tooltiptData.nameEvent;

                    // >>> Crew ------------------------------------------------
                    mycrew = '';
                    roles = '';
                    tmp = '';
                    flight.crew.forEach((crew, i) => {
                        mycrew = mycrew + crew.contract3Code;

                        tmp = crew.onDuty ? ' <span style="color: red;">DU</span>' : ''; // onDuty
                        tmp += crew.takeoff === true || crew.landing === true ?  '(TL)' : '';
                        tmp += crew.manualStatus === 'C' ?  '(cd)' : '';
                        tmp += crew.manualStatus === 'E' ?  '(e)' : '';
                        mycrew = mycrew + tmp;

                        roles = '';
                        crew.roles.forEach((role, i) => { // Roles
                            roles = roles + ' ' + role.charAt(0);
                        });
                        mycrew = mycrew + roles;

                        mycrew = mycrew  + ',';
                    });
                    mycrew = mycrew.slice(0, -1);


                    // >>> Push ------------------------------------------------
                    t = {
                        originalId: flight.id, // Note: #67
                        resourceId: resourceId,
                        startDate: Vue.prototype.$buildUTCTime(flight.departureDateTimeLocal),
                        endDate: Vue.prototype.$buildUTCTime(flight.destinationDateTimeLocal),
                        name: 'FLIGHT', // for Tooltip Header
                        note: note,
                        // >>> ------------------
                        fromOriginal: null,
                        toOriginal: null,
                        // >>> ------------------
                        nameEvent: nameEvent,
                        crew: mycrew,
                        // >>> ------------------
                        iconCls: getColors.iconCls,
                        style: flight.dutyComment !== null ? 'border-right: 3px dotted #000;' : null,
                        eventColor: getColors.eventColor,
                        eventStyle: getColors.eventStyle,
                        cls: Vue.prototype.$getFlightsCls(flight.crew), // getColors.cls,
                        // >>> ------------------
                        requested: null,
                        activated: null,
                        remainingDayOff: null,
                        // >>> ------------------
                        idApt: null, // originally: AVAILABLE
                        aptCode: null,
                        // >>> ------------------
                        certificate: null, // originally: SICKNESS
                        fit: null,
                        sickOnTour: null,
                        sickChild: null,
                        // >>> ------------------ RESERVE
                        sleepFrom: null,
                        sleepTo: null,
                        // >>> ------------------ MEETING/FLIGHT
                        dutyComment: flight.dutyComment,
                        flightComment: flight.flightComment,
                        // >>> ------------------ STANDBY
                        activationDate: null,
                        // >>> ------------------ HOTEL
                        hotelObject: null,
                        // >>> ------------------ PRO
                        proObject: null,
                        // >>> ------------------ TRAINING
                        trainingObject: null,
                        // >>> ------------------ FLIGHT
                        flightId: null,
                        // >>> ------------------ VACATION
                        requestStatus: flight.requestStatus,
                    };
                    tmpArrayFlights.push(t);
                    // <<< Flight -----------------------------------





                    // >>> Checkin ----------------------------------
                    getColors = eventColors.find(colors => colors.duty === 'CICO');

                    note = ''; // reset
                    nameEvent = '';
                    tooltiptData = '';


                    // >>> Notes & More ----------------------------------------
                    flight.type = 'CI';
                    tooltiptData = Vue.prototype.$buildEventNote(flight);
                    note += tooltiptData.note;


                    // >>> Times -----------------------------------------------
                    utcDepartureTime = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).toDate();
                    utcArrivalTime = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).toDate();

                    year_departure_time = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).format('YYYY'); // New: #87
                    month_departure_time = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).format('MM');
                    day_departure_time = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).format('DD');
                    hours_departure_time = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).format('HH');
                    minutes_departure_time = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).format('mm');

                    year_arrival_time = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).format('YYYY');
                    month_arrival_time = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).format('MM');
                    day_arrival_time = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).format('DD');
                    hours_arrival_time = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).format('HH');
                    minutes_arrival_time = moment.utc(flight.dutyInfo.dutyCheckin, moment.ISO_8601).format('mm');

                    utcDepartureTime.setYear(year_departure_time); // New: #87
                    utcDepartureTime.setMonth(month_departure_time - 1);
                    utcDepartureTime.setDate(day_departure_time);
                    utcDepartureTime.setHours(hours_departure_time);
                    utcDepartureTime.setMinutes(minutes_departure_time - 1); // little Correction

                    utcArrivalTime.setYear(year_arrival_time);
                    utcArrivalTime.setMonth(month_arrival_time - 1);
                    utcArrivalTime.setDate(day_arrival_time);
                    utcArrivalTime.setHours(hours_arrival_time);
                    utcArrivalTime.setMinutes(minutes_arrival_time - 1); // little Correction


                    // >>> Push ------------------------------------------------
                    if (String(datebefore) !== String(utcDepartureTime) || (String(datebefore) === String(utcDepartureTime) && resourceIdBefore !== resourceId)) {
                        t2 = {
                            originalId: flight.id, // Note: #67
                            resourceId: resourceId,
                            startDate: utcDepartureTime,
                            endDate: utcArrivalTime,
                            name: 'CHECKIN', // for Tooltip Header
                            note: note,
                            // >>> ------------------
                            fromOriginal: null,
                            toOriginal: null,
                            // >>> ------------------
                            nameEvent: '',
                            crew: '',
                            // >>> ------------------
                            iconCls: getColors.iconCls,
                            style: null,
                            eventColor: getColors.eventColor,
                            eventStyle: getColors.eventStyle,
                            cls: getColors.cls,
                            // >>> ------------------
                            requested: null,
                            activated: null,
                            remainingDayOff: null,
                            // >>> ------------------
                            idApt: null, // originally: AVAILABLE
                            aptCode: null,
                            // >>> ------------------
                            certificate: null, // originally: SICKNESS
                            fit: null,
                            sickOnTour: null,
                            sickChild: null,
                            // >>> ------------------ RESERVE
                            sleepFrom: null,
                            sleepTo: null,
                            // >>> ------------------ MEETING
                            dutyComment: null,
                            flightComment: null,
                            // >>> ------------------ STANDBY
                            activationDate: null,
                            // >>> ------------------ HOTEL
                            hotelObject: null,
                            // >>> ------------------ PRO
                            proObject: null,
                            // >>> ------------------ TRAINING
                            trainingObject: null,
                            // >>> ------------------ FLIGHT
                            flightId: null,
                            // >>> ------------------ VACATION
                            requestStatus: flight.requestStatus,
                        };
                        datebefore = utcDepartureTime;
                        resourceIdBefore = resourceId;
                        tmpArrayCiCos.push(t2);
                    }
                    // <<< Checkin ----------------------------------





                    // >>> Checkout ---------------------------------
                    note = ''; // reset
                    nameEvent = '';
                    tooltiptData = '';


                    // >>> Notes & More ----------------------------------------
                    flight.type = 'CO';
                    tooltiptData = Vue.prototype.$buildEventNote(flight);
                    note += tooltiptData.note;


                    // >>> Times -----------------------------------------------
                    utcDepartureTime = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).toDate();
                    utcArrivalTime = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).toDate();

                    year_departure_time = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).format('YYYY'); // New: #287
                    month_departure_time = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).format('MM');
                    day_departure_time = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).format('DD');
                    hours_departure_time = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).format('HH');
                    minutes_departure_time = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).format('mm');

                    year_arrival_time = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).format('YYYY');
                    month_arrival_time = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).format('MM');
                    day_arrival_time = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).format('DD');
                    hours_arrival_time = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).format('HH');
                    minutes_arrival_time = moment.utc(flight.dutyInfo.dutyCheckout, moment.ISO_8601).format('mm');

                    utcDepartureTime.setYear(year_departure_time); // New: #287
                    utcDepartureTime.setMonth(month_departure_time - 1);
                    utcDepartureTime.setDate(day_departure_time);
                    utcDepartureTime.setHours(hours_departure_time);
                    utcDepartureTime.setMinutes(minutes_departure_time);

                    utcArrivalTime.setYear(year_arrival_time);
                    utcArrivalTime.setMonth(month_arrival_time - 1);
                    utcArrivalTime.setDate(day_arrival_time);
                    utcArrivalTime.setHours(hours_arrival_time);
                    utcArrivalTime.setMinutes(minutes_arrival_time);


                    // >>> Push ------------------------------------------------
                    if (String(datebefore2) !== String(utcDepartureTime) || (String(datebefore2) === String(utcDepartureTime) && resourceIdBefore2 !== resourceId)) {
                        t3 = {
                            originalId: flight.id, // Note: #67
                            resourceId: resourceId,
                            startDate: utcDepartureTime,
                            endDate: utcArrivalTime,
                            name: 'CHECKOUT', // for Tooltip Header
                            note: note,
                            // >>> ------------------
                            fromOriginal: null,
                            toOriginal: null,
                            // >>> ------------------
                            nameEvent: '',
                            crew: '',
                            // >>> ------------------
                            iconCls: getColors.iconCls,
                            style: null,
                            eventColor: getColors.eventColor,
                            eventStyle: getColors.eventStyle,
                            cls: getColors.cls,
                            // >>> ------------------
                            requested: null,
                            activated: null,
                            remainingDayOff: null,
                            // >>> ------------------
                            idApt: null, // originally: AVAILABLE
                            aptCode: null,
                            // >>> ------------------
                            certificate: null, // originally: SICKNESS
                            fit: null,
                            sickOnTour: null,
                            sickChild: null,
                            // >>> ------------------ RESERVE
                            sleepFrom: null,
                            sleepTo: null,
                            // >>> ------------------ MEETING
                            dutyComment: null,
                            flightComment: null,
                            // >>> ------------------ STANDBY
                            activationDate: null,
                            // >>> ------------------ HOTEL
                            hotelObject: null,
                            // >>> ------------------ PRO
                            proObject: null,
                            // >>> ------------------ TRAINING
                            trainingObject: null,
                            // >>> ------------------ FLIGHT
                            flightId: null,
                            // >>> ------------------ VACATION
                            requestStatus: flight.requestStatus,
                        };
                        datebefore2 = utcDepartureTime;
                        resourceIdBefore2 = resourceId;
                        tmpArrayCiCos.push(t3);
                    }
                    // <<< Checkout ---------------------------------
                });
            }
            // <<< ----------------------------------------

            // >>> 'proceedings' --------------------------
            if (item.proceedings.length) {
                item.proceedings.forEach(proceeding => {
                    const getColors = eventColors.find(colors => colors.duty === 'PROCEEDING');

                    note = ''; // reset
                    nameEvent = '';
                    tooltiptData = '';

                    // >>> Notes & More ----------------------------------------
                    proceeding.typeOfProceeding = proceeding.type; // special: cause 'type' exits already in pro
                    proceeding.type = 'PRO';
                    tooltiptData = Vue.prototype.$buildEventNote(proceeding);
                    note += tooltiptData.note;
                    nameEvent += tooltiptData.nameEvent;

                    // >>> Push ------------------------------------------------
                    t = {
                        originalId: proceeding.id, // Note: #67
                        resourceId: resourceId,
                        startDate: Vue.prototype.$buildUTCTime(proceeding.proceedingStart),
                        endDate: Vue.prototype.$buildUTCTime(proceeding.proceedingEnd),
                        name: 'PROCEEDING',
                        nameEvent: nameEvent,
                        note: note,
                        // >>> ------------------
                        fromOriginal: null,
                        toOriginal: null,
                        // >>> ------------------
                        iconCls: getColors.iconCls,
                        style: proceeding.status === 'PENDING' ? 'border: 1px solid red !important;' : null,
                        eventColor: getColors.eventColor,
                        eventStyle: getColors.eventStyle,
                        cls: getColors.cls,
                        // >>> ------------------
                        requested: null,
                        activated: null,
                        remainingDayOff: null,
                        // >>> ------------------
                        idApt: null, // originally: AVAILABLE
                        aptCode: null,
                        // >>> ------------------
                        certificate: null, // originally: SICKNESS
                        fit: null,
                        sickOnTour: null,
                        sickChild: null,
                        // >>> ------------------ RESERVE
                        sleepFrom: null,
                        sleepTo: null,
                        // >>> ------------------ MEETING
                        dutyComment: null,
                        flightComment: null,
                        // >>> ------------------ STANDBY
                        activationDate: null,
                        // >>> ------------------ HOTEL
                        hotelObject: null,
                        // >>> ------------------ PRO
                        proObject: proceeding,
                        // >>> ------------------ TRAINING
                        trainingObject: null,
                        // >>> ------------------ FLIGHT
                        flightId: null,
                        // >>> ------------------ VACATION
                        requestStatus: proceeding.requestStatus,
                    };
                    tmpArrayProceedings.push(t);
                });
            }
            // <<< ----------------------------------------

            // >>> 'hotels' -------------------------------
            if (item.hotels.length) {
                item.hotels.forEach(hotel => {
                    const getColors = eventColors.find(colors => colors.duty === 'HOTEL');

                    note = ''; // reset
                    nameEvent = '';
                    tooltiptData = '';

                    // >>> Notes & More ----------------------------------------
                    hotel.type = 'HOTEL';
                    tooltiptData = Vue.prototype.$buildEventNote(hotel);
                    note += tooltiptData.note;
                    nameEvent += tooltiptData.nameEvent;

                    // >>> Push ------------------------------------------------
                    t = {
                        originalId : hotel.id,  // Note: #67
                        resourceId: resourceId,
                        startDate: Vue.prototype.$buildUTCTime(hotel.checkinDate),
                        endDate: Vue.prototype.$buildUTCTime(hotel.checkoutDate),
                        name: 'HOTEL',
                        nameEvent: nameEvent,
                        note: note,
                        // >>> ------------------
                        fromOriginal: null,
                        toOriginal: null,
                        // >>> ------------------
                        iconCls: getColors.iconCls,
                        style: null,
                        eventColor: getColors.eventColor,
                        eventStyle: getColors.eventStyle,
                        cls: getColors.cls,
                        // >>> ------------------
                        requested: null,
                        activated: null,
                        remainingDayOff: null,
                        // >>> ------------------
                        idApt: null, // originally: AVAILABLE
                        aptCode: null,
                        // >>> ------------------
                        certificate: null, // originally: SICKNESS
                        fit: null,
                        sickOnTour: null,
                        sickChild: null,
                        // >>> ------------------ RESERVE
                        sleepFrom: null,
                        sleepTo: null,
                        // >>> ------------------ MEETING
                        dutyComment: null,
                        flightComment: null,
                        // >>> ------------------ STANDBY
                        activationDate: null,
                        // >>> ------------------ HOTEL
                        hotelObject: hotel,
                        // >>> ------------------ PRO
                        proObject: null,
                        // >>> ------------------ TRAINING
                        trainingObject: null,
                        // >>> ------------------ FLIGHT
                        flightId: null,
                        // >>> ------------------ VACATION
                        requestStatus: hotel.requestStatus,
                    };
                    tmpArrayHotels.push(t);
                });
            }
            // <<< ----------------------------------------

            // >>> 'trainings' ----------------------------
            if (item.trainings.length) {
                item.trainings.forEach(training => {
                    const getColors = eventColors.find(colors => colors.duty === 'TRAINING');

                    note = ''; // reset
                    nameEvent = '';
                    tooltiptData = '';

                    // >>> Notes & More ----------------------------------------
                    training.type = 'TRAINING';
                    tooltiptData = Vue.prototype.$buildEventNote(training);
                    note += tooltiptData.note;
                    nameEvent += tooltiptData.nameEvent;

                    // >>> Push ------------------------------------------------
                    t = {
                        originalId : training.id,  // Note: #67
                        resourceId: resourceId,
                        startDate: Vue.prototype.$buildUTCTime(training.nextCheckStartDate),
                        endDate: Vue.prototype.$buildUTCTime(training.nextCheckEndDate),
                        name: 'TRAINING',
                        nameEvent: nameEvent,
                        note: note,
                        // >>> ------------------
                        fromOriginal: null,
                        toOriginal: null,
                        // >>> ------------------
                        iconCls: getColors.iconCls,
                        style: training.activated === true ? 'border: 1px solid red !important;' : null,
                        eventColor: getColors.eventColor,
                        eventStyle: getColors.eventStyle,
                        cls: getColors.cls,
                        // >>> ------------------
                        requested: null,
                        activated: null,
                        remainingDayOff: null,
                        // >>> ------------------
                        idApt: null, // originally: AVAILABLE
                        aptCode: null,
                        // >>> ------------------
                        certificate: null, // originally: SICKNESS
                        fit: null,
                        sickOnTour: null,
                        sickChild: null,
                        // >>> ------------------ RESERVE
                        sleepFrom: null,
                        sleepTo: null,
                        // >>> ------------------ MEETING
                        dutyComment: null,
                        flightComment: null,
                        // >>> ------------------ STANDBY
                        activationDate: null,
                        // >>> ------------------ HOTEL
                        hotelObject: null,
                        // >>> ------------------ PRO
                        proObject: null,
                        // >>> ------------------ TRAINING
                        trainingObject: training,
                        // >>> ------------------ FLIGHT
                        flightId: null,
                        // >>> ------------------ VACATION
                        requestStatus: training.requestStatus,
                    };
                    tmpArrayTrainings.push(t);
                });
            }
            // <<< ----------------------------------------

            // >>> 'breaks' -------------------------------
            if (item.breaks.length) {
                item.breaks.forEach(mybreak => {
                    const getColors = eventColors.find(colors => colors.duty === mybreak.type);

                    note = ''; // reset
                    nameEvent = '';
                    tooltiptData = '';
                    style = null;
                    utcDepartureTimeActivation = null;

                    // >>> Notes & More ----------------------------------------
                    tooltiptData = Vue.prototype.$buildEventNote(mybreak);
                    note += tooltiptData.note;
                    nameEvent += tooltiptData.nameEvent;

                    // >>> Times -----------------------------------------------
                    if (mybreak.type !== 'SICKNESS' && mybreak.type !== 'DAYOFF' && mybreak.type !== 'FREEDAY' && mybreak.type !== 'VACATION' && mybreak.type !== 'UNABLEFLIGHT' && mybreak.type !== 'AVAILABLE') {
                        utcDepartureTime = Vue.prototype.$buildUTCTime(mybreak.from);
                        utcArrivalTime = Vue.prototype.$buildUTCTime(mybreak.to);
                    }

                    if (mybreak.type === 'SICKNESS' || mybreak.type === 'DAYOFF' || mybreak.type === 'FREEDAY' || mybreak.type === 'VACATION' || mybreak.type === 'UNABLEFLIGHT' || mybreak.type === 'AVAILABLE') {
                        utcDepartureTime = moment.utc(mybreak.from, moment.ISO_8601).toDate();
                        utcArrivalTime = moment.utc(mybreak.to, moment.ISO_8601).toDate();

                        utcDepartureTime.setHours(0);
                        utcDepartureTime.setMinutes(0);
                        utcArrivalTime.setHours(23);
                        utcArrivalTime.setMinutes(59);
                    }

                    // >>> Others ----------------------------------------------
                    if (mybreak.type === 'DAYOFF') {
                        style = mybreak.activated === true ? 'color: white; background: repeating-linear-gradient(45deg, #ffe81c,#ffe81c 10px,#c0af1a 10px,#c0af1a 20px);' : null;

                        if (mybreak.dutyComment !== null) {
                            if (style !== null) {
                                style = style + ' border-right: 3px dotted #000;';
                            } else {
                                style = ' border-right: 3px dotted #000;';
                            }
                        }
                    }

                    if (mybreak.type === 'FREEDAY') {
                        // style = mybreak.activated === true ? 'border-color: #27ca37; color: #27ca37;' : null;
                        style = mybreak.activated === true ? 'color: white; background: repeating-linear-gradient(45deg, #ffe81c,#ffe81c 10px,#c0af1a 10px,#c0af1a 20px)' : null;

                        if (mybreak.dutyComment !== null) {
                            if (style !== null) {
                                style = style + ' border-right: 3px dotted #000;';
                            } else {
                                style = ' border-right: 3px dotted #000;';
                            }
                        }
                    }

                    if (mybreak.type === 'RES') {
                        utcDepartureTimeSleep = Vue.prototype.$buildUTCTime(mybreak.sleepFrom);
                        utcArrivalTimeSleep = Vue.prototype.$buildUTCTime(mybreak.sleepTo);
                    }

                    if (mybreak.type === 'STANDBY') {
                        if (mybreak.activationDate !== null) {
                            utcDepartureTimeActivation = Vue.prototype.$buildUTCTime(mybreak.activationDate);
                            style = 'background: repeating-linear-gradient(45deg,#b28b84,#b28b84 10px,#d8cdcb 10px,#d8cdcb 20px); color: #fff;';
                        };
                        if (mybreak.dutyComment !== null) {
                            if (style !== null) {
                                style = style + ' border-right: 3px dotted #000;';
                            } else {
                                style = ' border-right: 3px dotted #000;';
                            }
                        }
                    }

                    if (mybreak.type === 'AVAILABLE') {
                        if (mybreak.dutyComment !== null) {
                            if (style !== null) {
                                style = style + ' border-right: 3px dotted #000;';
                            } else {
                                style = ' border-right: 3px dotted #000;';
                            }
                        }
                    }

                    if (mybreak.type === 'OFFICE') {
                        if (mybreak.dutyComment !== null) {
                            if (style !== null) {
                                style = style + ' border-right: 3px dotted #000;';
                            } else {
                                style = ' border-right: 3px dotted #000;';
                            }
                        }
                    }

                    if (mybreak.type === 'VACATION') {
                        style = mybreak.requestStatus === 'REQUESTED' || mybreak.requestStatus === 'MAINREQUEST' || mybreak.requestStatus === 'SECONDARYREQUEST' || mybreak.requestStatus === 'REPLACEMENTREQUEST' ? 'background: repeating-linear-gradient(45deg, #ececec,#ececec 10px,#ccc 10px,#ccc 20px)' : null;

                        if (mybreak.dutyComment !== null) {
                            if (style !== null) {
                                style = style + ' border-right: 3px dotted #000;';
                            } else {
                                style = ' border-right: 3px dotted #000;';
                            }
                        }
                    }

                    if (mybreak.type === 'RES') {
                        if (mybreak.dutyComment !== null) {
                            if (style !== null) {
                                style = style + ' border-right: 3px dotted #000;';
                            } else {
                                style = ' border-right: 3px dotted #000;';
                            }
                        }
                    }

                    if (mybreak.type === 'SICKNESS') {
                        if (mybreak.dutyComment !== null) {
                            if (style !== null) {
                                style = style + ' border-right: 3px dotted #000;';
                            } else {
                                style = ' border-right: 3px dotted #000;';
                            }
                        }
                    }


                    // >>> Push ------------------------------------------------
                    t = {
                        originalId : mybreak.id, // Note: #67
                        resourceId: resourceId,
                        startDate: utcDepartureTime,
                        endDate: utcArrivalTime,
                        name: getColors.breakName.toUpperCase(),
                        nameEvent: nameEvent,
                        note: note,
                        // >>> ------------------
                        fromOriginal: mybreak.from,
                        toOriginal: mybreak.to,
                        // >>> ------------------
                        iconCls: getColors.iconCls,
                        style: style,
                        eventColor: getColors.eventColor,
                        eventStyle: getColors.eventStyle,
                        cls: getColors.cls,
                        // >>> ------------------
                        requested: mybreak.requested,
                        activated: mybreak.activated,
                        remainingDayOff: mybreak.remainingDayOff,
                        // >>> ------------------ AVAILABLE, STANDBY & more
                        idApt: mybreak.idApt,
                        aptCode: mybreak.aptCode,
                        // >>> ------------------ SICKNESS
                        certificate: mybreak.certificate,
                        fit: mybreak.fit,
                        sickOnTour: mybreak.sickOnTour,
                        sickChild: mybreak.sickChild,
                        // >>> ------------------ RESERVE
                        sleepFrom: utcDepartureTimeSleep,
                        sleepTo: utcArrivalTimeSleep,
                        // >>> ------------------ MEETING
                        dutyComment: mybreak.dutyComment,
                        flightComment: null,
                        // >>> ------------------ STANDBY
                        activationDate: utcDepartureTimeActivation,
                        // >>> ------------------ HOTEL
                        hotelObject: null,
                        // >>> ------------------ PRO
                        proObject: null,
                        // >>> ------------------ TRAINING
                        trainingObject: null,
                        // >>> ------------------ FLIGHT
                        flightId: null,
                        // >>> ------------------ VACATION
                        requestStatus: mybreak.requestStatus,
                    };
                    tmpArrayBreaks.push(t);

                });
            }
            // <<< ----------------------------------------

        });


        // >>> -----------------------------------------------------------------// add into Scheduler
        tmpArrayResources.sort((a,b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));
        state.cc_Resources = tmpArrayResources;                                 // push resources


        state.cc_Events.push(...tmpArrayFlights);                               // push events
        state.cc_Events.push(...tmpArrayCiCos);
        state.cc_Events.push(...tmpArrayProceedings);
        state.cc_Events.push(...tmpArrayTrainings);
        state.cc_Events.push(...tmpArrayBreaks);
        state.cc_Events.push(...tmpArrayHotels);


        state.cc_ResourceTimeRanges_BirthdatesCache.push(...tmpArrayResourceBirthdate); // Buffer/Cache
        state.cc_ResourceTimeRanges.push(...tmpArrayResourceBirthdate); // push birthdates

    }, // eo function mut_load_ListEmployeesSchedulerDetails()


    /***************************************************************************
    * mut_load_ListRestrictions()
    *
    * Desc:
    * Note:
    *
    */
    mut_load_ListRestrictions: (state, payload) => {

        let tmpArrayRestrictions = [],
            startDateTmp = '',
            endDateTmp = '',
            startDateTmp5 = '',
            endDateTmp5 = '';


        payload.forEach((resource, i) => {
            if (resource.restrictions.length > 0) {
                resource.restrictions.forEach((restriction, j) => {
                    startDateTmp = state.cc_ListEmployeesSchedulerSearchData.from.substring(0,4) + moment(restriction.fromDate).format('-MM-DD').toString() + 'T00:00';
                    endDateTmp = state.cc_ListEmployeesSchedulerSearchData.from.substring(0,4) + moment(restriction.toDate).format('-MM-DD').toString() + 'T23:59';

                    // Zeitzone extrahieren
                    const timezoneOffset = moment(restriction.fromDate).utcOffset();

                    // Stundenkorrektur und Formatierung der Daten
                    startDateTmp5 = moment(restriction.fromDate).utcOffset(timezoneOffset).subtract(timezoneOffset, 'minutes').format('YYYY-MM-DDTHH:mm');
                    endDateTmp5 = moment(restriction.toDate).utcOffset(timezoneOffset).subtract(timezoneOffset, 'minutes').format('YYYY-MM-DDTHH:mm');

                    if (restriction.type === 'MINRP') {
                        tmpArrayRestrictions.push(
                            { resourceId : resource.idResource, startDate : startDateTmp5, endDate : endDateTmp5, name : '', cls: restriction.error === false ? 'restriction' : 'restrictionerror' },
                        );
                    } else {
                        tmpArrayRestrictions.push(
                            { resourceId : resource.idResource, startDate : startDateTmp, endDate : endDateTmp, name : '', cls: 'restrictionalternative' },
                        );
                    }



                });
            }

        });


        state.cc_ResourceTimeRanges.push(...state.cc_ResourceTimeRanges_BirthdatesCache); // push birthdates
        state.cc_ResourceTimeRanges.push(...tmpArrayRestrictions); // push timeranges
        state.cc_ResourceTimeRangesWarningsList.push(...payload); // warnigs list

    }, // eo function mut_load_ListRestrictions()




    /***************************************************************************
    * Mutations: 'CrewCalendar' - Save Search Data
    ***************************************************************************/
    /***************************************************************************
    * mut_set_SchedulerSearch()
    *
    * Desc: Save Scheduler Search Data.
    * Note:
    *
    */
    mut_set_SchedulerSearch: (state, payload) => {

        state.cc_ListEmployeesSchedulerSearchData = payload;

    }, // eo function mut_set_SchedulerSearch()




    /***************************************************************************
    * Mutations: 'CrewCalendar' - Reset
    ***************************************************************************/
    /***************************************************************************
    * mut_reset_SchedulerData()
    *
    * Desc:
    * Note:
    *
    */
    mut_reset_SchedulerData: (state, payload) => {

        state.cc_Resources = [];
        state.cc_Events = [];
        // state.cc_ResourceTimeRanges = [];

    }, // eo function mut_reset_SchedulerData()


    /***************************************************************************
    * mut_reset_SchedulerTimeRanges()
    *
    * Desc:
    * Note:
    *
    */
    mut_reset_SchedulerTimeRanges: (state, payload) => {

        state.cc_ResourceTimeRanges = [];
        state.cc_ResourceTimeRangesWarningsList = [];

    }, // eo function mut_reset_SchedulerTimeRanges()




    /***************************************************************************
    * Mutations: 'CrewCalendar' - Flags
    ***************************************************************************/
    /***************************************************************************
    * mut_setFlag_dataIsFresh()
    *
    * Desc:
    * Note:
    *
    */
    mut_setFlag_dataIsFresh: (state, payload) => {

        state.dataIsFresh = payload;

    }, // eof mut_setFlag_dataIsFresh()




    /***************************************************************************
    * Mutations: 'CrewCalendar' - Set selected Multi Events/Resources.
    ***************************************************************************/
    /***************************************************************************
    * mut_set_SelectedMultiEvents()
    *
    * Desc: Set selected Multi Events.
    * Note:
    *
    */
    mut_set_SelectedMultiEvents: (context, payload) => {

        state.selectedMultiEventsEntireRecord = []; // reset
        state.selectedMultiEvents = []; // reset

        payload.forEach((item, i) => {
            state.selectedMultiEventsEntireRecord.push(item); // entire record
            state.selectedMultiEvents.push(item.data); // data only
        });

    }, // eo function mut_set_SelectedMultiEvents()


    /***************************************************************************
    * mut_set_SelectedMultiResources()
    *
    * Desc: Set selected Multi Resources.
    * Note:
    *
    */
    mut_set_SelectedMultiResources: (context, payload) => {

        state.selectedMultiResources = []; // reset
        payload.forEach((item, i) => {
            state.selectedMultiResources.push(item);
        });

    }, // eo function mut_set_SelectedMultiResources()


    /***************************************************************************
    * mut_setReset_SelectedMultiEventsEntireRecord()
    *
    * Desc: Reset
    * Note:
    *
    */
     mut_setReset_SelectedMultiEventsEntireRecord: (context, payload) => {

        state.selectedMultiEventsEntireRecord = []; // reset, more?

    }, // eo function mut_setReset_SelectedMultiEventsEntireRecord()

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: 'CrewCalendar' -  Load Scheduler Data
    ***************************************************************************/
    /***************************************************************************
    * Call: /humanresources/resource/report/breakdown/extends4
    *
    * Desc: (Call) - Load Scheduler Data
    * Note:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note: In 'SunCrew1' => 'load_ListEmployeesSchedulerDetails_NewSearchOnly'
    *
    */
    actn_load_ListEmployeesSchedulerDetails: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/report/breakdown/extends4';


        Vue.prototype.$vp_m();

        context.commit('mut_set_SchedulerSearch', payload); // save searchdata
        context.commit('mut_reset_SchedulerData', true); // reset scheduler
        eventBus.$emit('datechanged', payload); // emit immediately! (to set right scheduler starts/ends)

        axios.put(url, payload)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_load_ListEmployeesSchedulerDetails', response.data); // commit mutation:
                        context.commit('mut_setFlag_dataIsFresh', true);        // commit mutation: data is fresh again
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_load_ListEmployeesSchedulerDetails()


    /***************************************************************************
    * Call: /humanresources/resource/report/breakdown/extends4/restrictions
    *
    * Desc: (Call) - Load Restrictions.
    * Note:
    *
    */
    actn_load_ListRestrictions: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/report/breakdown/extends4/restrictions';


        context.commit('mut_reset_SchedulerTimeRanges', true); // reset timeranges

        axios.put(url, payload)
            .then(function (response) {
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_load_ListRestrictions', response.data); // commit mutation:
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                };
            })
            .catch(function (error) {
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_load_ListRestrictions()




    /***************************************************************************
    * Actions: 'CrewCalendar' - Set selected Multi Events/Resources.
    ***************************************************************************/
    /***************************************************************************
    * actn_set_SelectedMultiEvents()
    *
    * Desc: Set selected Multi Events.
    * Note:
    *
    */
    actn_set_SelectedMultiEvents: (context, payload) => {

        context.commit('mut_set_SelectedMultiEvents', payload); // save data

    }, // eo function actn_set_SelectedMultiEvents()


    /***************************************************************************
    * actn_set_SelectedMultiResources()
    *
    * Desc: Set selected Multi Resources.
    * Note:
    *
    */
    actn_set_SelectedMultiResources: (context, payload) => {

        context.commit('mut_set_SelectedMultiResources', payload); // save data

    }, // eo function actn_set_SelectedMultiResources()




    /***************************************************************************
    * Actions: 'CrewCalendar' - 'Switch Duty'.
    ***************************************************************************/
    /***************************************************************************
    * Call: '/humanresources/resource/dutyplan/generate'
    *
    * Desc: (Call) - 'Switch Duty'
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_switch_Duty: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/switchduties';


        Vue.prototype.$vp_m();
        axios.put(url, payload)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('updatedswitchduty', response.data);
                        context.commit('mut_setFlag_dataIsFresh', false);       // commit mutation: 'data is not fresh anymore'

                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Switch Duty - Worked - Still reload needed!'
                        });
                        break;

                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_switch_Duty()




    /***************************************************************************
    * Actions: 'CrewCalendar' - Update single Flight Comment
    ***************************************************************************/
    /***************************************************************************
    * Call: '/humanresources/flight/comment'
    *
    * Desc: (Call) - Update Flights Comment.
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_update_FlightComment: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/flight/comment';


        Vue.prototype.$vp_m();
        axios.put(url, payload)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('updateflightcomment', response.data);
                        eventBus.$emit('updatedmultipleflightcomments', response.data);

                        context.commit('mut_setFlag_dataIsFresh', false);       // commit mutation: 'data is not fresh anymore'
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Comment - Updated'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                    break;
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_update_FlightComment()




    /***************************************************************************
    * Actions: 'CrewCalendar' - Delete SINGLE Duty/Event/Break
    ***************************************************************************/
    /***************************************************************************
    * Call:
    *
    * Desc: (Call) - Delete single Duty.
    * Note: HTL, PRO, TRAINING (Special Breaks)
    * Note: STANDBY, DAYOFF (Common Breaks)
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_delete_SingleDuty: (context, payload) => {

        let hdrs = '',
            url = '';


        switch (payload.type) {
            case "HOTEL":
                url = '/humanresources/hotel/resource/';
                break;
            case "PROCEEDING":
                url = '/humanresources/resource/proceeding';
                break;
            case "TRAINING":
                url = '/humanresources/resource/training';
                break;
            case "STANDBY":
            case "DAYOFF":
            case "FREEDAY":
            case "MEETING":
            case "OFFICE":
            case "UNABLEFLIGHT":
            case "AVAILABLE":
            case "SICKNESS":
            case "RESERVE":
            case "VACATION":
                url = '/humanresources/resource/break';
                break;
            default:
        };

        url = url + '/' + payload.idToDelete;

        Vue.prototype.$vp_m();
        axios.delete(url, null)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_setFlag_dataIsFresh', false);       // commit mutation: (data is NOT resh anymore)
                        eventBus.$emit('deletedsingleduty',{ recs: payload.rec, response: response.data });

                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: payload.type + ' - Deleted'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                    break;
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_delete_SingleDuty()


    /***************************************************************************
    * Actions: 'CrewCalendar' - Delete ALL MARKED Duty/Event/Break
    ***************************************************************************/
    /***************************************************************************
    * Call: /humanresources/delete/multi
    *
    * Desc: (Call) - Delete all marked Duties
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_delete_AllMarkedDuties: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/delete/multi';


        Vue.prototype.$vp_m();
        axios.put(url, payload.params)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_setFlag_dataIsFresh', false);       // commit mutation: (data is NOT resh anymore)
                        context.commit('mut_setReset_SelectedMultiEventsEntireRecord');
                        eventBus.$emit('deletedallmarkedduties', { recs: payload.recs, response: response.data });

                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Multiple Events - Deleted'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                    break;
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_delete_AllMarkedDuties()




    /***************************************************************************
    * Actions: 'CrewCalendar' - Create/Update SINGLE Duty/Event/Break
    ***************************************************************************/
    /***************************************************************************
    * Call: /humanresources/resource/break'
    *
    * Desc: (Call) - Create single Duty.
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note: Gets OFF Step by Step (Building every Duty to multiple).
    *
    */
    actn_create_SingleDuty: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/break';


        Vue.prototype.$vp_m();
        axios.put(url, payload)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        switch (payload.type) {
                            // >>> ------------------------
                            case "DAYOFF":
                                eventBus.$emit('createdduty', response.data);
                                break;
                            case "AVAILABLE":
                                eventBus.$emit('createdduty', response.data);
                                break;
                            case "VACATION":
                                eventBus.$emit('createdduty', response.data);
                                break;
                            case "UNABLEFLIGHT":
                                eventBus.$emit('createdduty', response.data);
                                break;
                            case "FREEDAY":
                                eventBus.$emit('createdduty', response.data);
                                break;
                            case "SICKNESS":
                                eventBus.$emit('createdduty', response.data);
                                break;
                            case "RES":
                                eventBus.$emit('createdduty', response.data);
                                break;
                            case "OFFICE":
                                eventBus.$emit('createdduty', response.data);
                                break;
                            // case "MEETING":
                            //     eventBus.$emit('createdduty', response.data);
                            //     break;
                            case "STANDBY":
                                eventBus.$emit('createdduty', response.data);
                                break;
                            // <<< ------------------------
                            default:
                        }

                        context.commit('mut_setFlag_dataIsFresh', false);       // commit mutation: 'data is not fresh anymore'
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: payload.type + ' - Created'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_create_SingleDuty()


    /***************************************************************************
    * Call: /humanresources/resource/break'
    *
    * Desc: (Call) - Update single Duty.
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_update_SingleDuty: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/break';


        Vue.prototype.$vp_m();
        axios.put(url, payload)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        switch (payload.type) {
                            // >>> ------------------------
                            case "DAYOFF":
                                eventBus.$emit('updatedayoff', response.data[0]);
                                break;
                            case "AVAILABLE":
                                eventBus.$emit('updateavailable', response.data[0]);
                                break;
                            case "VACATION":
                                eventBus.$emit('updatevacation', response.data[0]);
                                break;
                            case "UNABLEFLIGHT":
                                eventBus.$emit('updateunableflight', response.data[0]);
                                break;
                            case "FREEDAY":
                                eventBus.$emit('updatefreeday', response.data[0]);
                                break;
                            case "SICKNESS":
                                eventBus.$emit('updatesickness', response.data[0]);
                                break;
                            case "RES":
                                eventBus.$emit('updatereserve', response.data[0]);
                                break;
                            case "OFFICE":
                                eventBus.$emit('updateoffice', response.data[0]);
                                break;
                            // case "MEETING":
                            //     eventBus.$emit('updatemeeting', response.data[0]);
                            //     break;
                            case "STANDBY":
                                if (payload.subtype === undefined) {
                                    eventBus.$emit('updatestandby', response.data[0]);
                                } else {
                                    eventBus.$emit('updatestandbyactivate', response.data[0]);
                                }
                                break;
                            default:
                        }

                        context.commit('mut_setFlag_dataIsFresh', false);       // commit mutation: 'data is not fresh anymore'
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: payload.type + ' - Updated'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                    break;
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_update_SingleDuty()




    /***************************************************************************
    * Actions: 'CrewCalendar' - Create/Update MULTIPLE Hotels
    ***************************************************************************/
    /***************************************************************************
    * Call: '/humanresources/resource/hotel
    *
    * Desc: (Call) - Create multiple Hotels.
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_create_Multiple_Hotels: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/hotel';


        Vue.prototype.$vp_m();
        axios.put(url, payload)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('createdmultiplehotels', response.data);
                        context.commit('mut_setFlag_dataIsFresh', false);       // commit mutation: 'data is not fresh anymore'
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Hotel(s) - Created'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_create_Multiple_Hotels()


    /***************************************************************************
    * Call: '/humanresources/resource/hotel/multi
    *
    * Desc: (Call) - Update multiple Hotels.
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_update_Multiple_Hotels: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/hotel/multi';


        Vue.prototype.$vp_m();
        axios.put(url, payload)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('updatedmultiplehotels', response.data);
                        context.commit('mut_setFlag_dataIsFresh', false);       // commit mutation: 'data is not fresh anymore'
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Hotel(s) - Updated'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_create_Multiple_Hotels()




    /***************************************************************************
    * Actions: 'CrewCalendar' - Create/Update multiple Proceedings
    ***************************************************************************/
    /***************************************************************************
    * Call: '/humanresources/resource/proceeding
    *
    * Desc: (Call) - Create multiple Proceedings.
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_create_Multiple_Proceedings: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/proceeding';


        Vue.prototype.$vp_m();
        axios.put(url, payload)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('createdmultipleproceedings', response.data);
                        context.commit('mut_setFlag_dataIsFresh', false);       // commit mutation: 'data is not fresh anymore'
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Proceeding(s) - Created'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_create_Multiple_Proceedings()


    /***************************************************************************
    * Call: '/humanresources/resource/hotel/multi
    *
    * Desc: (Call) - Update multiple Proceedings.
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_update_Multiple_Proceedings: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/proceeding/multi';


        Vue.prototype.$vp_m();
        axios.put(url, payload)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('updatedmultipleproceedings', response.data);
                        context.commit('mut_setFlag_dataIsFresh', false);       // commit mutation: 'data is not fresh anymore'
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Proceeding(s) - Updated'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_update_Multiple_Proceedings()




    /***************************************************************************
    * Actions: 'CrewCalendar' - Create/Update multiple Trainings
    ***************************************************************************/
    /***************************************************************************
    * Call: '/humanresources/resource/training'
    *
    * Desc: (Call) - Create multiple Trainings.
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_create_Multiple_Trainings: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/training';


        Vue.prototype.$vp_m();
        axios.put(url, payload)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('createdmultipletrainings', response.data);
                        context.commit('mut_setFlag_dataIsFresh', false);       // commit mutation: 'data is not fresh anymore'
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Training(s) - Created'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_create_Multiple_Trainings()


    /***************************************************************************
    * Call: '/humanresources/resource/trainings/multi'
    *
    * Desc: (Call) - Update multiple Trainings.
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_update_Multiple_Trainings: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/training/multi';


        Vue.prototype.$vp_m();
        axios.put(url, payload)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('updatedmultipletrainings', response.data);
                        context.commit('mut_setFlag_dataIsFresh', false);       // commit mutation: 'data is not fresh anymore'
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Training(s) - Updated'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_update_Multiple_Trainings()




    /***************************************************************************
    * Actions: 'CrewCalendar' - Create/Update MULTIPLE Duty/Event/Break
    ***************************************************************************/
    /***************************************************************************
    * Call: /humanresources/resource/break'
    *
    * Desc: (Call) - Create multiple Dut(ies)
    * Note:
    *
    */
    actn_create_Multiple_Duty: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/break';


        Vue.prototype.$vp_m();
        axios.put(url, payload)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        switch (payload.type) {
                            // >>> ------------------------
                            case "MEETING":
                                eventBus.$emit('createdmultipleduties', { response: response.data, type: payload.type } );
                                break;
                            // >>> ------------------------
                            case "STANDBY":
                                eventBus.$emit('createdmultipleduties', { response: response.data, type: payload.type } );
                                break;
                            // >>> ------------------------
                            case "SICKNESS":
                                eventBus.$emit('createdmultipleduties', { response: response.data, type: payload.type } );
                                break;
                            // <<< ------------------------
                            case "UNABLEFLIGHT":
                                eventBus.$emit('createdmultipleduties', { response: response.data, type: payload.type } );
                                break;
                            // <<< ------------------------
                            case "OFFICE":
                                eventBus.$emit('createdmultipleduties', { response: response.data, type: payload.type } );
                                break;
                            // <<< ------------------------
                            case "DAYOFF":
                                eventBus.$emit('createdmultipleduties', { response: response.data, type: payload.type } );
                                break;
                            // <<< ------------------------
                            default:
                                break;
                        }

                        context.commit('mut_setFlag_dataIsFresh', false);       // commit mutation: 'data is not fresh anymore'
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: payload.type + '(s) - Created'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_create_Multiple_Duty()


    /***************************************************************************
    * Call: /humanresources/resource/break/multi'
    *
    * Desc: (Call) - Update multiple Dut(ies)
    * Note:
    *
    */
    actn_update_Multiple_Duty: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/break/multi';


        Vue.prototype.$vp_m();
        axios.put(url, payload)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        switch (payload.breaks[0].type) {
                            // >>> ------------------------
                            case "MEETING":
                                eventBus.$emit('updatedmultipleduties', { response: response.data, type: payload.breaks[0].type} );
                                break;
                            // >>> ------------------------
                            case "STANDBY":
                                eventBus.$emit('updatedmultipleduties', { response: response.data, type: payload.breaks[0].type } );
                                break;
                            case "SICKNESS":
                                eventBus.$emit('updatedmultipleduties', { response: response.data, type: payload.breaks[0].type } );
                                break;
                            // >>> ------------------------
                            case "UNABLEFLIGHT":
                                eventBus.$emit('updatedmultipleduties', { response: response.data, type: payload.breaks[0].type } );
                                break;
                            // >>> ------------------------
                            case "OFFICE":
                                eventBus.$emit('updatedmultipleduties', { response: response.data, type: payload.breaks[0].type } );
                                break;
                            // <<< ------------------------
                            case "DAYOFF":
                                eventBus.$emit('updatedmultipleduties', { response: response.data, type: payload.breaks[0].type } );
                                break;
                            // <<< ------------------------
                            default:
                                break;
                        }

                        context.commit('mut_setFlag_dataIsFresh', false);       // commit mutation: 'data is not fresh anymore'
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: payload.breaks[0].type + '(s) - Updated'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_update_Multiple_Duty()




    /***************************************************************************
    * Actions: 'CrewCalendar' - MULTIPLE Sicknesses Change Status.
    ***************************************************************************/
    /***************************************************************************
    * Call: '/humanresources/resource/sickness/status/multi'
    *
    * Desc: (Call) - Update multiple Sicknesses.
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_changestatus_Multiple_Sicknesses: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/sickness/status/multi';


        Vue.prototype.$vp_m();
        axios.put(url, payload)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('changedstatusmultiplesicknesses', response.data);
                        context.commit('mut_setFlag_dataIsFresh', false); // commit mutation: 'data is not fresh anymore'

                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Sickness(es) - Status changed'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_changestatus_Multiple_Sicknesses()




    /***************************************************************************
    * Actions: 'CrewCalendar' - Change Status
    ***************************************************************************/
    /***************************************************************************
    * Call: /humanresources/resource/hotel/status/{id}/{status}
    *
    * Desc: (Call) - Set Hotels Status ('PENDING', 'BOOKING')
    * Note:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_set_HotelStatus: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/hotel/status/';


        url = url + payload.hotelId + '/' + payload.status;

        Vue.prototype.$vp_m();
        axios.get(url)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        payload.rec.nameEvent = 'HOTEL (' + response.data.status.toLowerCase() + ')';
                        context.commit('mut_setFlag_dataIsFresh', false);       // commit mutation: (data is NOT resh anymore)
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Hotel Status - CHANGED'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_set_HotelStatus()


    /***************************************************************************
    * Call: /humanresources/resource/hotel/status
    *
    * Desc: (Call) - Set Hotels Status ('PENDING', 'BOOKING')
    * Note:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_set_HotelStatusMultiple: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/hotel/status/';


        Vue.prototype.$vp_m();
        axios.put(url, payload.params)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_setFlag_dataIsFresh', false);       // commit mutation: data is fresh again
                        eventBus.$emit('changedmultiplehotelstatus', { recs: payload.recs, status: response.data[0].status });

                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Hotel(s) Status - CHANGED'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_set_HotelStatusMultiple()




    /***************************************************************************
    * Call: /humanresources/resource/proceeding/status/{id}/{status}
    *
    * Desc: (Call) - Set Proceedings Status ('PENDING', 'BOOKING')
    * Note:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_set_ProceedingStatus: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/proceeding/status/';


        url = url + payload.proceedingId + '/' + payload.status;

        Vue.prototype.$vp_m();
        axios.get(url)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        payload.rec.style = payload.style;
                        context.commit('mut_setFlag_dataIsFresh', false);       // commit mutation: (data is NOT resh anymore)
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Proceeding Status - CHANGED'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_set_ProceedingStatus()




    /***************************************************************************
    * Call: /humanresources/resource/break'
    *
    * Desc: (Call) -  Set Dayoff Activated, (same like: Modify single Duty).
    * Note:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_set_DayoffActivated: (context, payload) => {

        let hdrs = '',
            tooltipData = null,
            url = '/humanresources/resource/break';


        Vue.prototype.$vp_m();
        axios.put(url, payload.innerParams)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        payload.rec.set({ style: payload.style });
                        payload.rec.set({ activated: payload.innerParams.activated });
                        tooltipData = Vue.prototype.$buildEventNote(payload.rec); // rebuild Tooltip
                        payload.rec.set({ note: tooltipData.note });

                        context.commit('mut_setFlag_dataIsFresh', false); // commit mutation: data is fresh again
                        eventBus.$emit('deselectall');
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: payload.innerParams.type + ' - Modified'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_set_DayoffActivated()




    /***************************************************************************
    * Call: /humanresources/resource/break'
    *
    * Desc: (Call) -  Set Freeday Activated, (same like: Modify single Duty).
    * Note:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_set_FreedayActivated: (context, payload) => {

        let hdrs = '',
            tooltipData = null,
            url = '/humanresources/resource/break';


        Vue.prototype.$vp_m();
        axios.put(url, payload.innerParams)
            .then(function (response) {
                Vue.prototype.$vp_um();
                hdrs = response.headers['air41-status'];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        payload.rec.set({ style: payload.style });
                        payload.rec.set({ activated: payload.innerParams.activated });
                        tooltipData = Vue.prototype.$buildEventNote(payload.rec); // rebuild Tooltip
                        payload.rec.set({ note: tooltipData.note });

                        context.commit('mut_setFlag_dataIsFresh', false); // commit mutation: data is fresh again
                        eventBus.$emit('deselectall');
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: payload.innerParams.type + ' - Modified'
                        });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers['air41-error']
                        });
                };
            })
            .catch(function (error) {
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_set_FreedayActivated()

};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions
};